import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CdwDialogModule } from '@cdw-ae/common-ui-components-dialog';
import { CdwMessageBandModule } from '@cdw-ae/common-ui-components-message-band';
import { Store } from '@ngrx/store';
import * as AppLifecyclesActions from '../../../+state/app-lifecycles/app-lifecycles.actions';
import { selectSecondsRemaining } from '../../../+state/app-lifecycles/app-lifecycles.selectors';
import { SESSION_TIMEOUT_CONFIG } from '../../../+state/app-lifecycles/session-timeout.config';

/**
 * EDUS-2655 — the inactivity warning (Figma node 14662:61756).
 *
 * Deliberately inert: it renders store state and dispatches two actions, and
 * owns no timer of its own. Whoever opened it decides when it closes, which is
 * what makes the timeout survive a user deleting this element in devtools
 * (AC 1.4) — the countdown lives in the store, not here.
 */
@Component({
  selector: 'cdwae-session-timeout-dialog',
  standalone: true,
  imports: [CommonModule, CdwDialogModule, CdwMessageBandModule],
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss'],
})
export class SessionTimeoutDialogComponent {
  private readonly store = inject(Store);
  private readonly config = inject(SESSION_TIMEOUT_CONFIG);

  readonly secondsRemaining$ = this.store.select(selectSecondsRemaining);

  /**
   * Drives the copy, so a shortened test threshold cannot claim "29 minutes".
   * Floored at 1: the sub-minute thresholds used for manual testing would
   * otherwise render "inactive for 0 minutes".
   */
  readonly idleMinutes = Math.max(
    1,
    Math.round(this.config.idleWarningAfterMs / 60_000)
  );

  onStayLoggedIn(): void {
    this.store.dispatch(
      AppLifecyclesActions.sessionExtended({ atMs: Date.now() })
    );
  }

  onLogOutNow(): void {
    this.store.dispatch(AppLifecyclesActions.sessionLogoutRequested());
  }
}
